// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn{
    padding: 5px !important;
}

.loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.8); /* White with some transparency */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1050; /* Bootstrap's modal z-index is 1050 */
}

.nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {
  color: #fff;
  background-color: #17a2b8;
  border-color: #dee2e6 #dee2e6 #fff;
}

.nav-tabs .nav-link {
  color: #818182;
}
`, "",{"version":3,"sources":["webpack://./src/app/offer/mebo/mebo.component.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;AAC3B;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,0CAA0C,EAAE,iCAAiC;EAC7E,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa,EAAE,sCAAsC;AACvD;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".btn{\r\n    padding: 5px !important;\r\n}\r\n\r\n.loader-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background-color: rgba(255, 255, 255, 0.8); /* White with some transparency */\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 1050; /* Bootstrap's modal z-index is 1050 */\r\n}\r\n\r\n.nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {\r\n  color: #fff;\r\n  background-color: #17a2b8;\r\n  border-color: #dee2e6 #dee2e6 #fff;\r\n}\r\n\r\n.nav-tabs .nav-link {\r\n  color: #818182;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
